var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from "react";
import { getAuth, signInWithEmailAndPassword, } from "firebase/auth";
import { DevDaemonDBController } from "../DevDaemonDBController";
import { useAuthContext } from "../AuthContext";
import { Link, useHistory } from "react-router-dom";
import FormBox from "../components/FormBox";
import Button from "../components/Button";
import "./Login.css";
function Login() {
    var _this = this;
    var _a = useState(""), teamName = _a[0], setTeamName = _a[1];
    var _b = useState(""), email = _b[0], setEmail = _b[1];
    var _c = useState(""), password = _c[0], setPassword = _c[1];
    var _d = useAuthContext(), app = _d.app, setDBCtrler = _d.setDBCtrler;
    var history = useHistory();
    var handleSubmit = function (event) {
        event.preventDefault();
        var auth = getAuth(app);
        var defaultSignInTransaction = function (userCredential) { return __awaiter(_this, void 0, void 0, function () {
            var user_info, db_ctrler, joining_teams, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        user_info = userCredential.user;
                        db_ctrler = new DevDaemonDBController(app);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 5, 6, 7]);
                        return [4 /*yield*/, db_ctrler.setUserID(user_info.uid)];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, db_ctrler.setTeamID(teamName)];
                    case 3:
                        _a.sent();
                        return [4 /*yield*/, db_ctrler.getJoiningTeamList()];
                    case 4:
                        joining_teams = _a.sent();
                        if (!joining_teams.find(function (team) { return db_ctrler.teamID === team.path.id; })) {
                            throw new Error("あなたは，このチームに所属していません");
                        }
                        history.push("/checkstatus");
                        return [3 /*break*/, 7];
                    case 5:
                        error_1 = _a.sent();
                        alert(error_1);
                        auth.signOut();
                        history.push("/");
                        return [3 /*break*/, 7];
                    case 6:
                        setDBCtrler(db_ctrler);
                        return [7 /*endfinally*/];
                    case 7: return [2 /*return*/];
                }
            });
        }); };
        signInWithEmailAndPassword(auth, email, password)
            .then(defaultSignInTransaction)
            .catch(function (error) {
            var errorCode = error.code;
            var errorMessage = error.message;
            alert("\u30ED\u30B0\u30A4\u30F3\u306B\u5931\u6557\u3057\u307E\u3057\u305F (Code:" + errorCode + ")\n" + errorMessage);
        });
    };
    return (_jsxs("div", __assign({ className: "login-style" }, { children: [_jsx("h1", { children: "\u958B\u767A\u3092\u898B\u5B88\u308B" }, void 0), _jsxs("form", __assign({ onSubmit: handleSubmit }, { children: [_jsx(FormBox, { name: "team", type: "text", placeholder: "\u30C1\u30FC\u30E0\u540D", onChange: setTeamName }, void 0), _jsx(FormBox, { name: "email", type: "email", placeholder: "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9", onChange: setEmail }, void 0), _jsx(FormBox, { name: "password", type: "password", placeholder: "\u30D1\u30B9\u30EF\u30FC\u30C9", onChange: setPassword }, void 0), _jsx(Button, { title: "\u30ED\u30B0\u30A4\u30F3", button_size: "medium-size", text_color: "text-white", bg_color: "bg-green" }, void 0), _jsx(Link, __assign({ to: "/signup", className: "create-account" }, { children: "\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u4F5C\u6210\u3059\u308B" }), void 0)] }), void 0)] }), void 0));
}
export default Login;



//////////////////
// WEBPACK FOOTER
// ./src/pages/Login.tsx
// module id = 58
// module chunks = 0